<template>
  <v-dialog
    max-width="700"
    v-model="isDialogOpen"
    @click:outside="closeDialog"
  >
    <v-card
      class="pa-4"
    >
      <page-title :value="`新規献立種別作成`" />

      <div class="my-4">
        <v-text-field
          v-model="categoryName"
          variant="outlined"
          label="種別名"
          color="primary"
        />
      </div>
      <div class="my-4">
        <v-select
          v-model="targetClassIds"
          multiple
          variant="outlined"
          label="対象クラス"
          :items="classes"
          :item-title="(item) => item.year + '年度' + item.className"
          item-value="classId"
          color="primary"
        />
      </div>

      <v-progress-linear v-if="isCreating" indeterminate color="primary" class="my-4" />

      <div class="my-4 d-flex align-center">
        <v-spacer />
        <v-btn
          color="primary"
          variant="flat"
          :disabled="!isCreationValid || isCreating"
          @click="createCategory"
        >作成</v-btn>
        <v-spacer />
      </div>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import { foodMenusModule } from '@/store/viewModules/food-menu/foodMenusModule';

import PageTitle from '@/components/atoms/PageTitle.vue';
import { classModule } from '@/store/dataModules/classModule';
import LocalDataService from '@/service/LocalDataService';

interface DataType {
  categoryName: string;
  targetClassIds: number[];

  isCreating: boolean;
}

export default defineComponent({
  components: {
    PageTitle,
  },

  data: (): DataType => ({
    categoryName: '',
    targetClassIds: [],

    isCreating: false,
  }),

  computed: {
    isDialogOpen() {
      return foodMenusModule.isCreateCategoryDialogOpen;
    },
    classes() {
      return classModule.classes;
    },
    isCreationValid() {
      if (
        this.categoryName.trim().length > 0
        && this.targetClassIds.length > 0
      ) {
        return true;
      }
      return false;
    }
  },

  methods: {
    closeDialog() {
      this.categoryName = '';
      this.targetClassIds = [];
      foodMenusModule.setIsCreateCategoryDialogOpen(false);
    },
    async createCategory() {
      this.isCreating = true;
      await foodMenusModule.createCategory({
        name: this.categoryName,
        targetClassIds: this.targetClassIds,
      });
      await foodMenusModule.listMealCategories();
      this.isCreating = false;
      foodMenusModule.setIsCreateCategoryDialogOpen(false);
    }
  },

  mounted() {
    const nurseryId = LocalDataService.getNurseryId();
    if (nurseryId) {
      classModule.listClass({ nurseryId });
    }
  }
});
</script>
